export const container: CSSFunction<{height?: number}> = ({ cssProps }) => ({
  minHeight: cssProps.height ?? '100%',
});
